import styled, { css, DefaultTheme } from 'styled-components';
import { rgba } from 'polished';

type WrapperProps = {
  variant: 'primary' | 'secondary' | 'third';
};

const wrapperModifiers = (theme: DefaultTheme) => ({
  primary: css`
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0px 4px 8px ${rgba(theme.colors.globalBlack100, 0.05)};
  `,
  secondary: css`
    border-radius: 16px;
    padding: 40px;
    box-shadow: none;

    @media (max-width: 992px) {
      padding: 32px 16px;
    }
  `,
  third: css`
    border-radius: 8px;
    padding: 24px;
    border: 1px solid ${theme.colors.neutralSilver20};
  `,
});

export const Wrapper = styled.aside<WrapperProps>`
  ${({ theme, variant }) => css`
    background-color: ${theme.colors.globalWhite100};
    border: 1px solid ${theme.colors.neutralSilver10};
    width: 100%;

    ${wrapperModifiers(theme)[variant]}
  `}
`;
